Number.isNaN = Number.isNaN || function(value) {
    return typeof value === "number" && isNaN(value);
}
export default undefined;